module.exports = __webpack_public_path__ + "img/env_4.f9bea820.jpg";